import React from "react";
import styled from "styled-components";
import { Container, Section } from "../components/ui/Container";
import { ExternalButton, LinkButton } from "../components/ui/Button";
import { fonts, media, radius } from "../theme";

export const CTA = () => (
  <Section tight>
    <Container>
      <Wrap>
        <Bg src={process.env.PUBLIC_URL + "/images/carpenter-business.jpg"} alt="" />
        <Overlay />
        <Inner>
          <h2>Real returns. Real impact. Real businesses you can see.</h2>
          <p>
            Open an account in minutes. Fund a loan, or apply for one. The whole
            journey is mobile first and built for Uganda.
          </p>
          <Row>
            <ExternalButton
              variant="white"
              href="https://invest.everpesa.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open my account
            </ExternalButton>
            <LinkButton variant="outlineWhite" to="/contact">Talk to our team</LinkButton>
          </Row>
        </Inner>
      </Wrap>
    </Container>
  </Section>
);

const Wrap = styled.div`
  position: relative;
  border-radius: ${radius.xl};
  overflow: hidden;
  isolation: isolate;
  padding: 80px 56px;
  ${media.md} { padding: 56px 28px; }
`;

const Bg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  background:
    linear-gradient(120deg, rgba(0,15,61,0.96) 0%, rgba(0,51,204,0.85) 60%, rgba(0,51,204,0.55) 100%);
`;

const Inner = styled.div`
  color: white;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 18px;

  h2 {
    color: white;
    font-family: ${fonts.display};
    font-size: clamp(1.8rem, 3.6vw, 2.6rem);
    line-height: 1.15;
  }
  p { color: rgba(255,255,255,0.85); font-size: 17px; max-width: 580px; }
`;

const Row = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
`;
